import { useExperimentalFeatures } from '../contexts/ExperimentalFeaturesContext';
import { isExperimentalFeaturesEnabled } from './experimentalFeatures';

/**
 * Subscription product surfaces follow the experimental features toggle.
 *
 * When off:
 * - complete-profile creates host/tutor accounts immediately (no /onboarding/plan)
 * - user profile shows org-type picker instead of a pricing CTA for non-hosts
 * - public /pricing and footer pricing link are hidden
 *
 * Host Plan and Billing (`/host/subscription`) stays available regardless of this toggle.
 *
 * When on:
 * - user profile prompts non-hosts to view /pricing (“Do you host or teach?”)
 */
export function isSubscriptionFeaturesEnabled(): boolean {
  return isExperimentalFeaturesEnabled();
}

/** Reactive React gate — preferred inside components under ExperimentalFeaturesProvider. */
export function useSubscriptionFeaturesEnabled(): boolean {
  return useExperimentalFeatures().enabled;
}
